import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';


const getEnv = () => {
    if (window.location.href.includes('localhost')) 
        return 'local';
    
    if (window.location.href.includes('staging.')) 
        return 'staging';
    
    if (window.location.href.includes('dev.')) 
        return 'dev';
    
    return 'production'; // default to production if none of the above match
}



datadogRum.init({
    applicationId: '7c061971-8b7d-40d6-950b-55fa5a385428',
    clientToken: 'pub7ba12859752c78d5ab302b87ceef8a04',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'us5.datadoghq.com',
    service: 'ta-frontend',
    env: getEnv(),
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 50,
    defaultPrivacyLevel: 'mask-user-input',
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    enablePrivacyForActionName: true,
  });

ReactDOM.render(<App />, document.getElementById('root'));